import { Wind, PersonStanding, Clock } from "lucide-react";

const OCUPACION_LABEL = { ocupado: "Ocupado", libre: "Libre" };
const hora = (iso) => (iso ? String(iso).slice(11, 16) : null);

// R8 · estado ACTUAL que el radar VS373 publica (ocupación y último reporte periódico). Es un
// OBSERVABLE del sensor, no un caso: no tiene prioridad, ni responsable, ni SLA. Una lectura
// respiratoria sólo se muestra cuando el propio sensor la marcó como válida.
export const RadarEstadoVS373 = ({ estado, deviceId }) => {
  if (!estado) return null;
  const oc = estado.ocupacion;
  const per = estado.periodico;
  // La lectura del reporte periódico manda; si no hay, se usa la que llegó en el trigger.
  const resp = estado.respiracion;
  const rpm = per?.breath_rate_valido ? per.breath_rate : (resp?.valido ? resp.valor : null);
  const uso = Number.isFinite(per?.current_use_time) ? per.current_use_time : null;
  if (!oc && !per && !resp) return null;
  return (
    <p
      className="text-xs text-slate-500 dark:text-slate-400 mt-1 ml-6 flex flex-wrap items-center gap-x-2 gap-y-0.5"
      data-testid={`device-vs373-estado-${deviceId}`}
    >
      <span className="uppercase tracking-wide text-[10px] text-slate-400">Radar VS373</span>
      {oc?.valor && (
        <span className="flex items-center gap-1" data-testid={`device-vs373-ocupacion-${deviceId}`}>
          <PersonStanding strokeWidth={1.75} className="h-3.5 w-3.5" />
          {OCUPACION_LABEL[oc.valor] || oc.valor}
          {hora(oc.actualizado_en) && <span className="text-slate-400">({hora(oc.actualizado_en)})</span>}
        </span>
      )}
      {rpm !== null && (
        <>
          <span aria-hidden>·</span>
          <span className="flex items-center gap-1" data-testid={`device-vs373-respiracion-${deviceId}`}>
            <Wind strokeWidth={1.75} className="h-3.5 w-3.5" />
            Respiración reportada: {rpm} rpm
          </span>
        </>
      )}
      {(per || resp) && rpm === null && (
        <>
          <span aria-hidden>·</span>
          <span data-testid={`device-vs373-respiracion-sin-lectura-${deviceId}`}>
            Respiración: sin lectura válida
          </span>
        </>
      )}
      {uso !== null && (
        <>
          <span aria-hidden>·</span>
          <span className="flex items-center gap-1"><Clock strokeWidth={1.75} className="h-3.5 w-3.5" /> Uso actual: {uso} min</span>
        </>
      )}
    </p>
  );
};
